import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { IncomingInvoiceUpdatePaymentFormViewProps } from "models/propTypes/incomingInvoicePropTypes";
import { FormEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { DateFormFieldProps, FormHandles } from "models/propTypes/genericFormProps";
import { IncomingInvoiceFormTypes } from "models/formTypes";
//#endregion
//#region components
import GenericForm from "components/common/forms/genericForm";
//#endregion

const IncomingInvoiceUpdatePaymentForm: ForwardRefRenderFunction<
  FormHandles,
  IncomingInvoiceUpdatePaymentFormViewProps
> = (props, ref) => {
  return (
    <GenericForm<IncomingInvoiceFormTypes.UpdatePayment>
      formRef={ref}
      {...props}
      fields={{
        paymentDate: {
          label: TranslationKeys.Common.PaymentDate,
          controlLabel: TranslationKeys.Common.PaymentDateChangeLabel,
          type: FormEnums.FormFieldType.DATE,
          descriptionText: TranslationKeys.IncomingInvoice.UpdatePaymentPaymentDateHelpText,
          extraProps: {
            minDate: new Date(),
          } as DateFormFieldProps<IncomingInvoiceFormTypes.UpdatePayment>,
        },
      }}
      enableControlLables
    />
  );
};

export default forwardRef(IncomingInvoiceUpdatePaymentForm);
